import {
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router";
import { iDataComponentes } from "../../interfaces/SuperAdmin/Others/iDataComponentes";
import { useActividadesContext } from "../UmmIACategories/Hook/useActividades";

interface Props {
  app: iDataComponentes;
}

const AppsCard: FC<Props> = ({ app }) => {
  const navigate = useNavigate();
  const { changeApp } = useActividadesContext();

  const handleChange = () => {
    changeApp(app);
    navigate(`/asistente/${app.route}`);
  };

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: "400px",
        borderRadius: "20px",
        transition: "transform 0.05s ease-in-out, box-shadow 0.3s ease-in-out",
        ":hover": {
          transform: "scale(1.00)",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <CardActionArea onClick={handleChange}>
        <CardMedia
          component="img"
          image={app.img}
          alt={app.alt}
          sx={{
            width: "100%",
            aspectRatio: 2 / 1,
            objectFit: "contain",
            height: "auto",
          }}
        />

        <Grid
          sx={{
            position: "relative",
            with: "100%",
            color: "White",
            backgroundColor: "#FAFAFA",
            minHeight: "180px",
            display: "flex",
            flexDirection: "column",
            padding: { xs: 1, sm: 2 },
            gap: { xs: 1.5, sm: 2 },
            py: 1,
          }}
        >
          <Typography
            variant="h6"
            fontFamily={"Montserrat"}
            color={"#336B87"}
            fontWeight={"bold"}
            sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem" } }}
          >
            {app.nombre}
          </Typography>
          <Typography
            component="p"
            fontFamily={"Montserrat"}
            color={"rgba(0, 0, 0, 0.6)"}
            fontWeight={"medium"}
            sx={{ fontSize: { xs: "0.85rem", sm: "1rem" } }}
          >
            {app.descripcion}
          </Typography>
        </Grid>
      </CardActionArea>
    </Card>
  );
};

export default AppsCard;
